import React from "react"
import { PhotoProvider, PhotoConsumer } from "react-photo-view"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const MasonryVariant = ({ images, lightbox }) => {
  return (
    <section className="overflow-hidden text-gray-700">
      <div className="container mx-auto py-2 sm:px-5 lg:px-32 lg:pt-5 ">
        {lightbox ? (
          <PhotoProvider>
            <div className="-m-1 flex flex-wrap md:-m-2">
              <div className="flex w-1/2 flex-wrap justify-center">
                {images &&
                  images?.map((image, index) => {
                    const gatsbyImage =
                      image?.masonryImage &&
                      getImage(image?.masonryImage?.gatsbyImage)
                    if (!gatsbyImage) {
                      return null
                    }
                    return (
                      index <= 2 && (
                        <PhotoConsumer
                          key={index}
                          src={gatsbyImage?.images?.fallback?.src}
                        >
                          <div
                            className={
                              index === 2
                                ? "w-[85%] p-1 sm:w-full md:p-2"
                                : "w-[85%] p-1 sm:w-1/2 md:p-2"
                            }
                          >
                            <GatsbyImage
                              alt={image?.altText || ""}
                              image={gatsbyImage}
                              objectFit={"contain"}
                              className="block h-full cursor-pointer rounded-lg object-cover object-center sm:w-full "
                            />
                          </div>
                        </PhotoConsumer>
                      )
                    )
                  })}
              </div>
              <div className="flex w-1/2 flex-wrap justify-center">
                {images &&
                  images?.map((image, index) => {
                    const gatsbyImage =
                      image?.masonryImage &&
                      getImage(image?.masonryImage?.gatsbyImage)
                    if (!gatsbyImage) {
                      return null
                    }
                    return (
                      index > 2 &&
                      index <= 5 && (
                        <PhotoConsumer
                          key={index}
                          src={gatsbyImage?.images?.fallback?.src}
                        >
                          <div
                            className={
                              index === 3
                                ? "w-[85%] p-1 sm:w-full md:p-2"
                                : "w-[85%] p-1 sm:w-1/2 md:p-2"
                            }
                          >
                            <GatsbyImage
                              alt={image?.altText || ""}
                              image={gatsbyImage}
                              className="block h-full cursor-pointer rounded-lg object-cover object-center sm:w-full"
                            />
                          </div>
                        </PhotoConsumer>
                      )
                    )
                  })}
              </div>
            </div>
          </PhotoProvider>
        ) : (
          <div className="-m-1 flex flex-wrap md:-m-2">
            <div className="flex  w-1/2 flex-wrap justify-center">
              {images &&
                images?.map((image, index) => {
                  const gatsbyImage =
                    image?.masonryImage &&
                    getImage(image?.masonryImage?.gatsbyImage)
                  if (!gatsbyImage) {
                    return null
                  }
                  return (
                    index <= 2 && (
                      <div
                        className={
                          index === 2
                            ? "w-[85%] p-1 sm:w-full md:p-2"
                            : "w-[85%] p-1 sm:w-1/2 md:p-2"
                        }
                      >
                        <GatsbyImage
                          alt={image?.altText || ""}
                          image={gatsbyImage}
                          className="block h-full rounded-lg object-cover object-center sm:w-full"
                        />
                      </div>
                    )
                  )
                })}
            </div>
            <div className="flex  w-1/2 flex-wrap justify-center">
              {images &&
                images?.map((image, index) => {
                  const gatsbyImage =
                    image?.masonryImage &&
                    getImage(image?.masonryImage?.gatsbyImage)
                  if (!gatsbyImage) {
                    return null
                  }
                  return (
                    index > 2 &&
                    index <= 5 && (
                      <div
                        className={
                          index === 3
                            ? "w-[85%] p-1 sm:w-full md:p-2"
                            : "w-[85%] p-1 sm:w-1/2 md:p-2"
                        }
                      >
                        <GatsbyImage
                          alt={image?.altText || ""}
                          image={gatsbyImage}
                          className="block h-full rounded-lg object-cover object-center sm:w-full"
                        />
                      </div>
                    )
                  )
                })}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default MasonryVariant
